import service from '@/request/service'

/**
 * 新研开始
 * pym
 * 获取解密列表以及上传
 *
 * **/
// 获取解密列表(开标人投标人统一)
export function getDecryptListPage(data) {
  return service({
    url: '/decrypt/listPage',
    method: 'post',
    data
  })
}

// 获取解密数量统计
export function getDecryptCount(data) {
  return service({
    url: '/decrypt/getCountStatistics',
    method: 'get',
    params: data
  })
}

// 获取当前投标人状态
export function getBidderList(data) {
  return service({
    url: '/decrypt/getById',
    method: 'get',
    params: data
  })
}

// 上传接口
export function decryptUploadFile(data) {
  return service({
    url: '/decrypt/uploadFile',
    method: 'post',
    data
  })
}

// 修改备注
export function updateRemark(data) {
  return service({
    url: '/decrypt/update',
    method: 'post',
    data
  })
}

// 结束解密
export function finishDecrypt(data) {
  return service({
    url: '/decrypt/finishDecrypt',
    method: 'post',
    data
  })
}

// 发起解密
export function goDecrypt(data) {
  return service({
    url: '/decrypt/startDecrypt',
    method: 'post',
    data
  })
}

// 获取解密信封信息
export function getDigitalEnvelope(data) {
  return service({
    url: '/decrypt/getDigitalEnvelope',
    method: 'post',
    data
  })
}

// 解密并更新秘钥信息
export function updateDigitalEnvelope(data) {
  return service({
    url: '/decrypt/updateDigitalEnvelope/' + data.domainId + '/' + data.openbidId + '/' + data.decryptRole,
    method: 'post',
    data: data.list
  })
}

// 一键解密
export function oneKeyDecrypt(data) {
  return service({
    url: '/decrypt/oneKeyDecrypt',
    method: 'post',
    data: data
  })
}

// 投标人解密
export function bidderPwdDecrypt(data) {
  return service({
    url: '/decrypt/bidderPwdDecrypt',
    method: 'post',
    data: data
  })
}

// 进度条
export function getDecryptSpeed(data) {
  return service({
    url: '/decrypt/getDecryptSpeed',
    method: 'post',
    data
  })
}

// 继续解密
export function goDecryptFile(data) {
  return service({
    url: '/decrypt/decryptFile',
    method: 'post',
    data
  })
}

// 获取解析方式
export function getParseType() {
  return service({
    url: '/decrypt/getParseType',
    method: 'get'
  })
}

// 招标人解析
export function tenderParse(data) {
  return service({
    url: '/decrypt/tenderParse',
    method: 'post',
    data
  })
}

// 获取解密解析状态
export function getBidderDecryptStatus(data) {
  return service({
    url: '/decrypt/getBidderDecryptStatus' + '/' + data.domainId + '/' + data.stage,
    method: 'get'
  })
}

// 获取解密开始和结束时间(自动解密)
export function getDecryptTime(data) {
  return service({
    url: 'decrypt/getDecryptTime',
    method: 'get',
    params: data
  })
}

// 获取是否有未解密的投标单位提示
export function validDecrypt(data) {
  return service({
    url: '/decrypt/validDecrypt',
    method: 'post',
    data
  })
}

/**
 * 新研结束
 * pym
 * 获取解密列表以及上传
 *
 * **/


/**
 * 旧接口
 *
 * **/
// 获取解密信息
// export function getBidDecrypt(data) {
//   return http({
//     url: '/openBidDecrypt/getBidSectionInfo',
//     method: 'post',
//     data,
//   })
// }

// 获取解密情况
// export function getDecryptInfo(data) {
//   return http({
//     url: '/openBidDecrypt/getDecryptInfo',
//     method: 'post',
//     data,
//   })
// }

// 解密列表
// export function getDecryptList(data) {
//   return http({
//     url: '/openBidDecrypt/getBidderList',
//     method: 'post',
//     data,
//   })
// }

// 获取上传的url
export function getUploadUrl() {
  return service({
    url: '/projectGen/getUploadUrl',
    method: 'post',
  })
}

// 解压文件去掉第一层壳
// export function extractFile(data) {
//   return http({
//     url: '/openBidDecrypt/extractFile',
//     method: 'post',
//     data,
//   })
// }

// 检验文件
// export function checkFile(data) {
//   return http({
//     url: '/openBidDecrypt/checkBidderFile',
//     method: 'post',
//     data,
//   })
// }

// 添加文件记录
export function addBidderFileRecord(data) {
  return service({
    url: '/openBidDecrypt/addBidderFileRecord',
    method: 'post',
    data,
  })
}

// 解压解析投标文件
// export function parseBidderFile(data) {
//   return http({
//     url: '/openBidDecrypt/parseBidderFile',
//     method: 'post',
//     data,
//   })
// }

// 获取处理投标文件进度
// export function getBidderProgress(data) {
//   return http({
//     url: '/openBidDecrypt/getBidderProgress',
//     method: 'post',
//     data,
//   })
// }

/* 根据投标文件ID（bidderFileId），查询投标文件信息 */
// export function getBidderFileInfoByBidderFileId(data) {
//   return http({
//     url: '/openBidDecrypt/getBidderFileInfoByBidderFileId',
//     method: 'post',
//     data,
//   })
// }

// 解密时间范围设置
// export function doOpenBidCatche(data) {
//   return http({
//     url: '/openBidDecrypt/doOpenBidCatche',
//     method: 'post',
//     data,
//   })
// }

// 调用服务端保存数字信封解密信息并解密投标文件(单体)(开标)
// export function decryptFile(data) {
//   return http({
//     url: '/openBidDecrypt/decryptFile',
//     method: 'post',
//     data,
//   })
// }

// 调用服务端保存数字信封解密信息并解密投标文件(单体)(投标)
// export function bidderMultistageDecrypt(data) {
//   return http({
//     url: '/openBidDecrypt/bidderMultistageDecrypt',
//     method: 'post',
//     data,
//   })
// }

// 调用服务端保存数字信封解密信息并解密投标文件(全部)
// export function decryptFileAll(data) {
//   return http({
//     url: '/openBidDecrypt/decryptFileAll',
//     method: 'post',
//     data,
//   })
// }

// 补充解压同步的文件，并且将解压结果入库
// export function extractAndAddFileInfo(data) {
//   return http({
//     url: '/openBidDecrypt/extractAndAddFileInfo',
//     method: 'post',
//     data,
//   })
// }

// 校验二维码
// export function tradeQrCode(data) {
//   return http({
//     url: '/ebidsunNeedLogin/tradeQrCode',
//     method: 'post',
//     data,
//   })
// }

// 二维码保存
// export function saveUuidProjectInfoToRedis(data) {
//   return http({
//     url: '/ebidsunNeedLogin/saveUuidProjectInfoToRedis',
//     method: 'post',
//     data,
//   })
// }

// 检查扫码状态
// export function getDecryptSecretByLocal(data) {
//   return http({
//     url: '/ebidsunNeedLogin/getDecryptSecretByLocal',
//     method: 'post',
//     data,
//   })
// }

// 清除缓存
// export function clearCacheResult(data) {
//   return http({
//     url: '/ebidsunNeedLogin/clearCacheResult',
//     method: 'post',
//     data,
//   })
// }

// 监控所有投标单位进度条
// export function getBidderProgressAll(data) {
//   return http({
//     url: '/openBidDecrypt/getBidderProgressAll',
//     method: 'post',
//     data,
//   })
// }

//根据多个投标人ID获取投标文件信息
// export function getBidderFileInfoByBidderIdAll(data) {
//   return http({
//     url: '/openBidDecrypt/getBidderFileInfoByBidderIdAll',
//     method: 'post',
//     data,
//   })
// }

//根据单个投标人ID获取投标文件信息
// export function getBidderFileInfoByBidderId(data) {
//   return http({
//     url: '/openBidDecrypt/getBidderFileInfoByBidderId',
//     method: 'post',
//     data,
//   })
// }

// 发起解密
export function startDecrypt(data) {
  return service({
    url: '/openBidDecrypt/startDecrypt',
    method: 'post',
    data,
  })
}
// 广联达E投(CA)解密
export function gldCaGetDecryptionUrl(data) {
  return service({
    url: '/decrypt/getDecryptionUrl',
    method: 'get',
    params: data
  })
}
// 获取投标人信息
// export function getBidderInfo(data) {
//   return http({
//     url: '/openBidDecrypt/getBidderInfo',
//     method: 'post',
//     data,
//   })
// }

// 结束解密
// export function finishDecrypt(data) {
//   return http({
//     url: '/openBidDecrypt/finishDecrypt',
//     method: 'post',
//     data,
//   })
// }

// 解密页面存储备注
// export function setBidderFileRemark(data) {
//   return http({
//     url: '/openBidDecrypt/setBidderFileRemark',
//     method: 'post',
//     data,
//   })
// }

/*是否需要解析*/
// export function dataDictonary(params) {
//   return http({
//     url: '/dataDictonary',
//     method: 'get',
//     params,
//   })
// }

// pdf报表导出
export function exportOpenPdf(data) {
  return service({
    url: '/report/getOpenPdfFile',
    method: 'post',
    data
  })
}
// 随机赋码
export function randomNumCreate(data) {
  return service({
    url: '/decrypt/randomNumCreate',
    method: 'get',
    params: data
  })
}
// 随机赋码状态
export function randomNumState(data) {
  return service({
    url: '/decrypt/randomNumState',
    method: 'get',
    params: data
  })
}
// 获取参数信息
export function decryptGetBidSectionInfo(data) {
  return service({
    url: '/decrypt/getBidSectionInfo',
    method: 'get',
    params: data
  })
}

// 确定投标入围
export function confirmBidderEntered(data) {
  return service({
    url: '/bidderEntered/confirmBidderEntered',
    method: 'post',
    data
  })
}

// 是否确认过投标入围
export function hasConfirmBidderEntered(data) {
  return service({
    url: '/bidderEntered/hasConfirmBidderEntered',
    method: 'get',
    params: data
  })
}
// 是否已随机赋码
export function hasConfirmDelegateNo(data) {
  return service({
    url: '/bidderEntered/hasConfirmDelegateNo',
    method: 'get',
    params: data
  })
}

// 更新随机赋码方式
export function updateRandomCodingMethod(data) {
  return service({
    url: '/decrypt/updateRandomCodingMethod',
    method: 'get',
    params: data
  })
}
export function selectRandomCodingMethod(data) {
  return service({
    url: '/decrypt/selectRandomCodingMethod',
    method: 'get',
    params: data
  })
}


// 导入模板 
export function importTplExcel(data) {
  return service({
    url: '/bidderEntered/importExcel',
    method: 'post',
    data
  })
}
// 下载模板
export function exportBidderEnteredExcel(data) {
  return service({
    url: '/bidderEntered/exportBidderEnteredExcel',
    method: 'get',
    params: data
  })
}


// 检查解密解析状态
export function validParse(data) {
  return service({
    url: '/decrypt/validParse',
    method: 'post',
    data
  })
}
